import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4p9v4hk66: FaireProductEntity = {
  token: "p_b4p9v4hk66",
  type: "product",
  name: "Flocked Foam Squishies® Fidget Toy, Assorted Animals",
  brandToken: "b_8688sz59tv",
  brandName: "Showcase",
  imageUrl: "https://cdn.faire.com/fastly/7e352ff7744f85937bd5be495bb4dc82c38300f9d6ac12df00ddecdf143ce493.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ec13e3349d2527c5ac2e2dc06aca99596c98be9cb540f39a778357217edc3a5.jpeg",
    "https://cdn.faire.com/fastly/c7c61bc533ff3c47288d9596bc8102825c170edf9c13fd2b09d14ce328030a14.jpeg"
  ],
  priceDollars: 5.99,
  description: "Soft, fuzzy and seriously squishy. These little guys sell themselves once a customer picks one up.\n\nThe Flocked Foam Squishies® Fidget Toy pairs a slow, satisfying squish with a soft velvety flocked finish. It's a texture people don't expect, and that's what gets them to the register. Small size and an easy price point make it a natural impulse buy for checkout counters, gift shops, toy stores and anywhere kids (and grownups) browse.\n\nFour collectible animal designs keep shoppers coming back for the full set: penguin, seal, whale and hamster.\n\n🐧 Soft, squeezable PU foam core\n🐳 Fuzzy flocked exterior with a velvety feel\n🦭 Unique sensory texture that stands out on the shelf\n🐹 4 collectible animal designs\n📏 About 2.4 inches, perfect for desks, backpacks and fidget collections\n📦 Sold individually, designs ship assorted\n\nGreat as a stocking stuffer, party favor, classroom reward or just a little treat for anyone who loves cute and squishy.\n\nSquishies® is a registered trademark of Showcase®. Buy direct from the brand owner for authentic product.\n\n",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:00:36.064Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
